import { BaseMeiucaService } from './MeiucaService'
import { env } from '@/lib/env'
import type {
  ListTrainingCentersFilters,
  TrainingCenterDetail,
  TrainingCenterListItem
} from '../types/trainingCenter'

class TrainingCenterService extends BaseMeiucaService {
  async list(filters: ListTrainingCentersFilters = {}): Promise<TrainingCenterListItem[]> {
    const params = new URLSearchParams()

    if (filters.q) params.append('q', filters.q)
    if (filters.lat !== undefined) params.append('lat', String(filters.lat))
    if (filters.lng !== undefined) params.append('lng', String(filters.lng))
    if (filters.radius !== undefined) params.append('radius', String(filters.radius))
    if (filters.modalities?.length) params.append('modalities', filters.modalities.join(','))
    if (filters.remote) params.append('remote', 'true')

    const query = params.toString()
    const response = await this.get<{ data: TrainingCenterListItem[] }>(
      query ? `/training-centers?${query}` : '/training-centers'
    )

    return response.data.data
  }

  async getById(trainingCenterId: string): Promise<TrainingCenterDetail> {
    const response = await this.get<{ data: TrainingCenterDetail }>(
      `/training-centers/${trainingCenterId}`
    )

    return response.data.data
  }
}

export const trainingCenterService = new TrainingCenterService({
  baseURL: env.API_URL,
  refreshEndpoint: '/v1/auth/refresh',
  cookiePrefix: '',
  debug: env.IS_DEVELOPMENT,
})
